import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import sdk from '@/lib/kepler/sdk'
import {ParkingLot, Poi, Position, VehicleSlot} from '@/lib/kepler/interfaces'
import {RootState} from '@/store'

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>

export class Layer {
  public bookingMode: string
  public key: string
  public vehicles: VehicleSlot[]

  constructor(bookingMode: string, vehicles: VehicleSlot[], key: string) {
    this.bookingMode = bookingMode
    this.vehicles = vehicles
    this.key = key
  }
}

export interface LayerKey {
  booking_mode: string
  vehicle_type_id: string
  key: string
}

export interface Filter {
  [key: string]: boolean
}

export interface Filters {
  [type: string]: Filter
}

export class MapState {
  public currentPosition: Position = {
    latitude: 0,
    longitude: 0,
  }
  public filters: { [type: string]: { [id: string]: boolean } } = {}
  public parkingLots: ParkingLot[] = []
  public poi: Poi[] = []
  // public vehicles: VehicleSlot[] = []
}

const mutations: MutationTree<MapState> = {
  INIT(mState) {
    // keep current selections on init
    mState.filters = mState.filters ? mState.filters : {}
  },
  SET_POSITION(mState, payload: Position) {
    mState.currentPosition = payload
  },
  SET_FILTERS(mState, payload: Filters) {
    for (const [type, filter] of Object.entries(payload)) {
      if (!mState.filters[type]) {
        Vue.set(mState.filters, type, filter)
      }
      for (const [key, val] of Object.entries(filter)) {
        if (mState.filters[type][key]) {
          Vue.set(mState.filters[type], key, val)
        } else {
          mState.filters[type][key] = val
          Vue.set(mState.filters[type], key, val)
        }
        Vue.set(mState.filters[type], key, val)
      }
    }
  },
  REMOVE_FILTERS(mState, payload: string[]) {
    const v = mState.filters.vehicles
    if (v) {
      payload.forEach((key) => {
        if (v.hasOwnProperty(key)) {
          delete v[key]
        }
      })
    }
  },
  SET_POI(mState, payload: Poi[]) {
    mState.poi = payload
  },
  SET_PARKING_LOTS(mState, payload: ParkingLot[]) {
    mState.parkingLots = payload
  },
  // SET_VEHICLES(mapState, payload: VehicleSlot[]) {
  //   mapState.vehicles = payload
  // },
}

const actions: ActionTree<MapState, RootState> = {
  init({state, commit, dispatch}) {
    // do stuff on init
    const position = state.currentPosition
    if (!position) {
      commit('SET_POSITION', {
        latitude: 0,
        longitude: 0,
      })
    }
    if (!state.poi) {
      dispatch('getPoi')
    }
    if (!state.parkingLots) {
      dispatch('getParkingLots', position)
    }
    // dispatch('initFilterSearch', position)
  },
  setPosition({commit}, payload: Position) {
    commit('SET_POSITION', payload)
  },
  setFilters({commit, dispatch}, payload: Filters) {
    commit('SET_FILTERS', payload)
    dispatch('sleep')
  },
  removeFilters({commit, dispatch}, payload: Filters) {
    commit('REMOVE_FILTERS', payload)
    dispatch('sleep')
  },
  getPoi({commit}) {
    return sdk.map.getPoi()
      .then((r) => {
        commit('SET_POI', r.data)
        return r.data
      })
      .catch((e) => {
        // console.error(e)
      })
  },
  getParkingLots({state, commit}) {
    return sdk.booking.getParkingLots(state.currentPosition)
      .then((r) => {
        commit('SET_PARKING_LOTS', r.data)
      })
      .catch((e) => {
        // console.error(e)
      })
  },
  // getVehicles({commit}, payload: BookingSearchRequest) {
  //   return sdk.booking.search(payload.searchRequest)
  //     .then((r) => {
  //       commit('SET_VEHICLES', r.data)
  //     })
  //     .catch((e) => {
  //       // console.error(e)
  //     })
  // },
  // initFilterSearch({commit}) {
  //   // TODO: try that new show/hide system, show=id,position for super-aggressive filtering
  //   return sdk.map.vehicles(state.currentPosition).then((r) => {
  //     return commit('SET_VEHICLES', r.data)
  //   })
  // },

}

export default {
  state: new MapState(),
  mutations,
  actions,
}
